// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--2uwQq","content":"styles-module--content--1708a","header":"styles-module--header--2a5Xp","grid":"styles-module--grid--QNTwE"};